import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BarList from './BarList';

import transformArrayToBarChartObject from '../utils/transformArrayToBarChartObject';

const ChartWrapper = styled.div`
  height: ${props => props.theme.components.chartHeight};
  display: flex;
`;

function InterestsVisualisation({ data }) {
  if (!data?.interests) return false;

  const transformedData = transformArrayToBarChartObject(
    data?.interests,
    null,
    null,
    'title',
    false,
  ).slice(0, 3);

  return (
    <ChartWrapper>
      <BarList data={transformedData} />
    </ChartWrapper>
  );
}

InterestsVisualisation.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
export default InterestsVisualisation;
